import { FC, memo, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { doGetSidemenu } from '../../store/sidemenu.slice';
import { doRemoveAuth, setCurrentCampus } from '../../store/auth.slice';
import { RootState } from '../../store/rootReducer';
import { useSnackbar } from 'notistack';
import SubMenu from 'antd/lib/menu/SubMenu';
import SnackbarAction from '../SnackbarAction';
import { Link, useRouteMatch, useLocation, useParams } from 'react-router-dom';
import { Menu } from 'antd';
import { changeSelectMenu } from '../../store/menu.slice';

const Sidebar: FC = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { auth } = useSelector((state: RootState) => state.auth);
  const { sidemenu } = useSelector((state: RootState) => state.sidemenu);
  const { selectMenu, menu, menus } = useSelector((state: RootState) => state.menu);
  const { enqueueSnackbar } = useSnackbar();

  const location: any = useLocation();

  useEffect(() => {
    if (!auth) return;

    if (auth.memberType !== 'E') {
      dispatch(doRemoveAuth());
      return;
    }

    dispatch(setCurrentCampus(auth.campus[0]));
    getSideMenu();
  }, [auth]);


  const action = useCallback( (id: string | number) => {
    return <SnackbarAction id={id} />;
  }, []);

  const getSideMenu = useCallback(async () => {
    const res = await dispatch(doGetSidemenu());

    switch (res?.status) {
      case 200:
      case 403:
      case 404:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), {
          variant: 'error',
          persist: true,
          action
        });
    }
  }, [auth]);


  const linkTo = useCallback((event, selectMenu) => {
    if (event.target.nodeName === 'IMG') return;

    dispatch(changeSelectMenu(selectMenu));
  }, [location.pathname])

  const onOpenChange = (openKeys: string[]) => {
    const selectKey: any = {
      ...selectMenu,
      mainMenu: {
        ...selectMenu?.mainMenu,
        selectedKeys: openKeys,
      },
    };
    dispatch(changeSelectMenu(selectKey));
  }

  useEffect(() => {
    if (!sidemenu) return;

    const link: any = location?.state?.link;

    sidemenu.forEach(menu => {

      const subMenu = menu.secondaryMenu.find(sub => {
        if (link) {
          return link === sub.menuUrl;
        }

        return location.pathname === sub.menuUrl;
      });

      if (subMenu) {
        const data: any = {
          mainMenu: {
            info: menu,
            selectedKeys: [`${menu.menuCode}`]
          },
          subMenu: {
            info: subMenu,
            selectedKeys: [`${menu.menuCode}-${subMenu.menuCode}`]
          }
        }
        dispatch(changeSelectMenu(data));
        return;
      }
    })

  }, [sidemenu, location.pathname]);

  return (
    <div className="sidebar-area">
      <Link to="/" className="logo">
        <img
          className="brand-image"
          src={'/images/brand_white.png'}
          alt={t('common.layout.11')}
        />
      </Link>

      <div className="menu-area scrollbar">
        <nav className="menu-scroll">
          <Menu
            mode="inline"
            className='depth-one'
            onOpenChange={onOpenChange}
            openKeys={
              selectMenu
                ? selectMenu.mainMenu.selectedKeys
                : undefined}
            selectedKeys={
              selectMenu
                ? selectMenu?.subMenu?.selectedKeys
                : undefined
          }
          >
            {sidemenu.map((menu, index) => (
                <SubMenu
                  key={`${menu.menuCode}`}
                  style={{paddingLeft:0}}
                  title={
                    <a href='#' className='dep-link'>     
                      <img src={`/images/ic_${menu.iconName}.svg`} className="ic-menu" alt={t('common.layout.13')} />
                      <span className="menu-text-depth1">{ i18n.language === 'ko' ? menu.korName : menu.engName }</span>
                    </a>
                  }
                >
                  {menu.secondaryMenu.map((submenu, _i) => (
                    <Menu.Item 
                      key={`${menu.menuCode}-${submenu.menuCode}`}
                      style={{paddingLeft:0}}
                      >
                        <Link className="dep-link" to={submenu.menuUrl} onClick={event =>
                          linkTo(event, {
                            mainMenu: {
                              info: menu,
                              selectedKeys: [...(selectMenu?.mainMenu?.selectedKeys ?? []), `${menu.menuCode}`]
                            },
                            subMenu: {
                              info: submenu,
                              selectedKeys: [`${menu.menuCode}-${submenu.menuCode}`]
                            }
                        })}>
                          <div className="bx">                      
                            <p className="menu-text">
                              <span>{i18n.language === 'ko' ? submenu.korName : submenu.engName}</span>
                              <span className="ic-tab"
                                onClickCapture={(e) => {
                                  e.preventDefault();
                                  window.open(submenu.menuUrl, '_blank');
                                }}
                              >
                                <img src="/images/ic_tab.svg" style={{position: 'relative'}} alt="탭 새로 띄우기" />
                              </span>
                            </p>
                          </div>
                        </Link>
                    </Menu.Item>
                  ))} 
                </SubMenu>
            ))} 
          </Menu>
        </nav>
      </div>
    </div>
  )
}

export default memo(Sidebar);
